import React, { useRef, useState, useEffect } from 'react';
import { Modal, Button, Spinner, Form, Alert } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { setLocale } from 'yup';

import { ICON_SAVE, ICON_CANCEL } from '../../../../extras/icons';
import ButtonSpinner from '../../../../layout/ButtonSpinner';

//Redux
import { useDispatch, useSelector } from 'react-redux';
import { saveActsAction, updateActsAction } from '../../../../../actions/actsActions';

import { ACTA } from '../../../../../data/actsData';

//Función principal
const ActuationForm = props => {
    //Tomo los props
    const { show, handleClose, audience } = props;
    //Genero los refs
    const refConsiderando = useRef();
    const refContenido = useRef();
    //Datos iniciales
    const initialData = {
        adicional: '',
        considerando: '',
        resuelvo: '',
        contenido: ''
    }
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store de persona tipos
    const actsLoading = useSelector( state => state.acts.loadingSave );
    const errorSave = useSelector( state => state.acts.errorSave );
    const isEdit = useSelector( state => state.acts.isEdit );
    const actSelected = useSelector( state => state.acts.actSelected );
    const acts = useSelector( state => state.acts.acts );
    //Inicializo el state local
    const [ act, setAct ] = useState(initialData);
    //Modifico según el cambio
    useEffect(() => {
        //Me fijo si es edición
        if(isEdit && actSelected){
            setAct({
                ...actSelected
            });
        }else{
            setAct(initialData);
        }
    }, [isEdit, actSelected, show])
    //Manejo el guardado
    const handleSave = values => {
        //Agrego los nuevos valores
        let data = {
            tipo: ACTA,
            adicional: values.adicional,
            considerando: values.considerando,
            resuelvo: values.resuelvo,
            contenido: values.contenido,
            // audienciaid: audience.id,
            audiencia: {
                id: audience.id
            }
        }
        //Verifico si es edición o alta
        if(act.id){
            //Agrego el id
            data = {
                id: act.id,
                ...data
            }
            //Es edición
            dispatch( updateActsAction(data, handleCloseForm) );
        }else{
            //Es creación
            dispatch( saveActsAction(data, handleCloseForm) );
        }
        
    }
    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Pongo el foco en el primer campo
        refContenido.current.focus();
    }
    //Manejo cierre de la ventana
    const handleCloseForm = e => {
        //Reinicio datos
        setAct(initialData);
        //Cierro
        handleClose();
    }
    //Esquema de validación
    const validationSchema = yup.object({
        adicional: yup.string().nullable(),
        considerando: yup.string().nullable(),
        resuelvo: yup.string().nullable(),
        contenido: yup.string().nullable()
    });
    //Renderizo
    return (
        <Modal 
            show={show} 
            onHide={handleCloseForm} 
            onShow={handleOnShow} 
            aria-labelledby="contained-modal-title-vcenter" 
            centered
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Acta&nbsp;
                    <small><strong>{ isEdit ? 'Editar' : 'Nuevo' } Registro</strong></small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...act }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <div className="col-12">
                                    <Alert variant="info">
                                        Complete los campos que considere necesarios, los mismos se aplicarán al formato correspondiente. Luego deberá migrar el ACTA al SAE para poder completar la misma.
                                    </Alert>
                                </div>
                                <Form.Group className="col-md-12">
                                    <label htmlFor="contenido">Contenido</label>
                                    <Form.Control
                                        id="contenido"
                                        className="form-control" 
                                        autoFocus 
                                        name="contenido" 
                                        as="textarea"
                                        rows="3"
                                        ref={refContenido}
                                        value={ values.contenido }
                                        onChange={handleChange}
                                        isInvalid={!!errors.contenido}
                                        disabled={ actsLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.considerando }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <label htmlFor="considerando">Considerando</label>
                                    <Form.Control
                                        id="considerando"
                                        className="form-control" 
                                        autoFocus 
                                        name="considerando" 
                                        as="textarea"
                                        rows="3"
                                        ref={refConsiderando}
                                        value={ values.considerando }
                                        onChange={handleChange}
                                        isInvalid={!!errors.considerando}
                                        disabled={ actsLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.considerando }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <label htmlFor="resuelvo">Resuelvo</label>
                                    <Form.Control
                                        id="resuelvo"
                                        className="form-control" 
                                        autoFocus 
                                        name="resuelvo" 
                                        as="textarea"
                                        rows="3"
                                        value={ values.resuelvo }
                                        onChange={handleChange}
                                        isInvalid={!!errors.resuelvo}
                                        disabled={ actsLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.resuelvo }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <label htmlFor="adicional">Adicional</label>
                                    <Form.Control
                                        id="adicional"
                                        className="form-control" 
                                        autoFocus 
                                        name="adicional" 
                                        as="textarea"
                                        rows="3"
                                        value={ values.adicional }
                                        onChange={handleChange}
                                        isInvalid={!!errors.adicional}
                                        disabled={ actsLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.adicional }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                actsLoading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ actsLoading }>
                                        <ICON_SAVE /> <strong>GUARDAR</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleCloseForm} disabled={ actsLoading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default ActuationForm;